module.exports = "/_next/static/images/logoDesktop-7660654a31c99eb3723565f7ef9f8bce.svg";